import React from 'react';

import { Banner, Text } from '@betterment/samba-react';

export const TaxImpactPreviewInfoBanner: React.FC = () => {
  return (
    <Banner variant="info">
      <Banner.Content>
        <Text>Proceeds will be used to rebalance your client’s portfolio, bringing it closer to target.</Text>
      </Banner.Content>
    </Banner>
  );
};
